import { createContext } from "react";
import { makeObservable, observable, runInAction, toJS } from "mobx";
import Axios from "axios";
import { conditionConstants } from "../constants/condition.constants";
import { conditionTranslator } from "../helpers/condition.translator";
import { conditionNavigator } from "../helpers/condition.navigator";
import { defaultInvoiceFields } from "../constants/invoiceFields.constants";
import { getUrlParam } from "../helpers/url.helper";
import { deepClone, toCamelCase } from "../helpers/objectHelper";

var updateSqlStateTimeout;

export class Store {
  constructor() {
    makeObservable(this, {
      contentLayout: observable,
      modules: observable,
      environment: observable,
      current: observable,
      templates: observable,
      uploadedFonts: observable,
      googleFonts: observable,
      questions: observable,
      fields: observable,
      orders: observable,
      validations: observable,
      activePersonNo: observable,
      formState: observable,
      sqlStateNo: observable,
      validate: observable,
      conditions: observable,
      globalAlert: observable,
      countries: observable,
      eventLabels: observable,
      systemLabels: observable,
      contentHeaderLayout: observable,
      contentFooterLayout: observable,
      mainEvent: observable,
      displayConfirmationSettings: observable,
      displayEventSettings: observable,
      menuItems: observable,
      validatePaymentFields: observable,
      mainEventFullbooked: observable,
      voucherList: observable,
      breakoutsFullbooked: observable,
      defaultSelectedCountry: observable,
      hotels: observable,
      hotelAllotments: observable,
    });
  }

  environment = {
    name: "FORM",
    eventId: 172,
    lang: "swe",
    currency: "SEK", //?
  };
  event = {
    name: "Test event",
    languages: [
      { alpha3Code: "swe", alpha2Code: "" },
      { alpha3Code: "eng", alpha2Code: "" },
    ],
  };
  templates = [];
  breakoutsFullbooked = {};
  menuItems = [];
  mainEventFullbooked = false;
  contentHeaderLayout = null;
  contentFooterLayout = null;
  current = {
    selectedModule: null,
    activeLayout: null,
    activePage: 1,
    versionIndex: 0,
    template: null,
    payMethod: "",
    hasContentView: false,
    scopedLayout: false,
  };

  languages = [];
  contentLayout = null;
  fields = [];
  conditions = {};
  validate = false;
  validatePaymentFields = false;
  sqlStateNo = null;
  uploadedFonts = [];
  googleFonts = [];
  questions = [];
  xrayMode = false;
  breakouts = [];
  changeList = {};
  contentLayoutChanges = [];
  contentLayoutModuleChanges = [];
  contentModuleChanges = [];
  templateChanges = [];
  fieldChanges = [];
  questionChanges = [];
  breakoutChanges = [];
  displayEventSettings = [];
  displayConfirmationSettings = [];
  modules = [];
  validations = [];
  orders = [];
  activePersonNo = 0;
  formState = null;
  globalAlert = null;
  countries = [];
  eventLabels = {};
  systemLabels = {};
  mainEvent = null;
  voucherList = [];
  hotels = [];
  hotelAllotments = [];
  defaultSelectedCountry = 0;

  setActivePage = (int) => {
    runInAction(() => {
      this.current.activePage = int;
      if (this.contentLayout?.activateGroupLeaderOnPage && this.contentLayout?.activateGroupLeaderOnPage == this.current?.activePage) {
        runInAction(() => {
          let leader = this.orders.find((x) => x.leader);
          if (leader) {
            this.setActiveOrder(this.orders.indexOf(leader));
          }
        });
      }
    });
  };

  setBreakoutFullbooked = (eventId, bookedStatus) => {
    runInAction(() => {
      this.breakoutsFullbooked[eventId] = bookedStatus;
    });
    this.checkConditions();
  };

  setVoucherList = (list) => {
    runInAction(() => {
      this.voucherList = list;
    });
  };

  loadHotels = async () => {
    var response = await Axios.get(`./hotel/getHotelAllotments/${this.environment.eventId}`);
    runInAction(() => {
      this.hotels = response?.data?.hotels ?? [];
      this.hotelAllotments = response?.data?.allotments ?? [];
    });
  };

  setValidatePaymentFields = (val) => {
    runInAction(() => {
      this.validatePaymentFields = val;
    });
  };

  setMenuItems = (items) => {
    if (items !== "" && items !== undefined && items !== null) {
      runInAction(() => {
        this.menuItems = items;
      });
    }
  };

  isHiddenByConditions = (id) => {
    var hidden = false;
    let clm = this.contentLayout.contentLayoutModules.find((x) => x.contentModuleId == id);
    if (clm) {
      let isHidden = this.conditions[clm.contentLayoutModuleId]?.hidden;
      if (isHidden) {
        hidden = true;
      }
    }
    return hidden;
  };

  checkInvoiceValidation = (isValid) => {
    if (
      this.validations
        .filter((v) => v.page == this.current.activePage)
        .find((v) => v.id.toString().includes("INVOICE_") && this.current.payMethod != "invoice" && this.current.payMethod != "dibs" && this.current.payMethod != "stripe" && this.validatePaymentFields)
    ) {
      isValid = this.getFilteredValidations().length == 0;
    } else if (this.validations.filter((v) => v.page == this.current.activePage).find((v) => (v.id.toString().includes("INVOICE_") && this.current.payMethod != "invoice") || !this.validatePaymentFields)) {
      isValid = this.getFilteredValidations().length == 0;
    }
    return isValid;
  };

  getFilteredValidations = () => {
    const currentPageValidations = this.validations.filter((v) => v.page == this.current.activePage || v.page === 0);
    //if any id of any validations is an invoice field (aka includes INVOICE_), AND if current payMethod isn't invoice nor dibs, AND we're suppossed to validate fields
    if (currentPageValidations.find((v) => v.id.toString().includes("INVOICE_")) && !["invoice", "dibs", "stripe"].includes(this.current.payMethod) && this.validatePaymentFields) {
      //return any current page validation that is invalid, visible, and not invoice
      return currentPageValidations.filter((v) => v.valid == false && !this.isHiddenByConditions(v.id) && !v.id.toString().includes("INVOICE_"));
    }
    //if (any id of the validations is an invoice field (aka includes INVOICE_), AND if current payMethod isn't invoice), OR we're not supposed to validate payment fields
    else if (currentPageValidations.find((v) => (v.id.toString().includes("INVOICE_") && this.current.payMethod != "invoice") || !this.validatePaymentFields)) {
      //return any current page validation that is invalid, visible, and not invoice
      return currentPageValidations.filter((v) => v.valid == false && !this.isHiddenByConditions(v.id) && !v.id.toString().includes("INVOICE_") && v.label != "PaymentOption");
    } else {
      return currentPageValidations.filter((v) => v.valid == false && !this.isHiddenByConditions(v.id));
    }
  };
  //Registration
  register = (callback) => {
    let isValid = this.validations.filter((v) => v.valid == false && !this.isHiddenByConditions(v.id)).length == 0;
    if (this.current.payMethod == "dibs" || this.current.payMethod === "stripe") isValid = this.getFilteredValidations().filter((v) => v.valid == false).length == 0;
    isValid = this.checkInvoiceValidation(isValid);
    if (isValid) {
      let orders = Array.from(this.orders);
      if (this.current.payMethod) {
        orders.map((o) => {
          o.payMethod = this.current.payMethod;
          o.contentLayoutId = this.contentLayout.contentLayoutId;
          if (!o.webConfirmationId) o.webConfirmationId = this.contentLayout.webConfirmation;
          if (!o.emailConfirmationId) o.emailConfirmationId = this.contentLayout.emailConfirmation;
          if (!o.secondaryEmailConfirmationId) o.secondaryEmailConfirmationId = this.contentLayout.secondaryEmailConfirmation;
        });
      } else {
        orders.map((o) => {
          o.contentLayoutId = this.contentLayout.contentLayoutId;
          if (!o.webConfirmationId) o.webConfirmationId = this.contentLayout.webConfirmation;
          if (!o.emailConfirmationId) o.emailConfirmationId = this.contentLayout.emailConfirmation;
          if (!o.secondaryEmailConfirmationId) o.secondaryEmailConfirmationId = this.contentLayout.secondaryEmailConfirmation;
        });
      }

      const dto = [];

      orders.forEach((o) => {
        const order = {
          orderId: o.orderId ? o.orderId : null,
          eventIds: [],
        };

        if (o.orderRow) {
          o.orderRow
            .filter(({ orderRowId }) => orderRowId < 0)
            .forEach((or) => {
              order.eventIds.push(or.eventId);
            });
        }
        if (!order.discounts) {
          order.discounts = [];
        }
        if (order.eventIds.length > 0) {
          dto.push(order);
        }
      });

      if (dto.length > 0) {
        Axios.post(`./api/attendee/statusrange/${this.sqlStateNo}`, dto).then(({ data }) => {
          if (data.available) {
            if (this.contentLayout.type === "SURVEY") this.surveyPost(orders, callback);
            else this.formPost(orders, callback);
          } else {
            alert("OrderRowFull");
          }
        });
      } else {
        if (this.contentLayout.type === "SURVEY") this.surveyPost(orders, callback);
        else this.formPost(orders, callback);
      }
    }
  };

  showQuestionModule = (id) => {
    var foundModule = true;
    var specificModule = this.contentLayout.contentLayoutModules.find((x) => x.contentModule.type == "QUESTION" && x.contentModule.settings.questionId == id);
    if (specificModule) {
      let isHidden = this.conditions[specificModule.contentLayoutModuleId]?.hidden;
      if (isHidden) {
        foundModule = false;
      }
    }
    return foundModule;
  };

  formPost = (orders, callback) => {
    orders = deepClone(orders);
    //exclude hidden required questions
    orders.forEach((order) => {
      if (order.answer && order.answer.length > 0) {
        order.answer.forEach((question) => {
          let include = this.showQuestionModule(question.questionId);
          if (!include) {
            order.answer = order.answer.filter((x) => x.questionId != question.questionId);
          }
        });
      }
    });

    Axios.post(`./api/cms/post/`, orders)
      .then(({ data }) => {
        let item = localStorage.getItem("formstates");
        if (item) {
          let states = JSON.parse(item);
          let prevState = states.find((s) => s.formId === this.contentLayout.contentLayoutId && s.expires > Date.now());
          if (prevState) {
            states.splice(states.indexOf(prevState), 1);
            localStorage.setItem("formstates", JSON.stringify(states));
          }
        }
        if (typeof callback === "function") {
          callback(true);
        }

        const searchParams = new URLSearchParams(window.location.search);
        const station = searchParams.get("station");
        window.location.href = window.location.origin + (!window.location.href.includes("localhost") ? "/cms" : "") + data.redirectUrl + (station ? "&station=" + station : "");
      })
      .catch((err) => {
        if (typeof callback === "function") {
          callback(false);
        }
        this.globalAlert = "RegisterFailed";
      });
  };

  surveyPost = (orders, callback) => {
    Axios.post(`./api/cms/postSurvey/`, orders)
      .then(({ data }) => {
        let item = localStorage.getItem("formstates");
        if (item) {
          let states = JSON.parse(item);
          let prevState = states.find((s) => s.formId === this.contentLayout.contentLayoutId && s.expires > Date.now());
          if (prevState) {
            states.splice(states.indexOf(prevState), 1);
            localStorage.setItem("formstates", JSON.stringify(states));
          }
        }
        if (typeof callback === "function") {
          callback(true);
        }
        window.location.href = window.location.origin + (!window.location.href.includes("localhost") ? "/cms" : "") + data.redirectUrl;
      })
      .catch((err) => {
        if (typeof callback === "function") {
          callback(false);
        }
        this.globalAlert = "RegisterFailed";
      });
  };

  updateSqlState = () => {
    let storageStates = localStorage.getItem("formstates");
    let formStates = undefined;

    if (storageStates) {
      formStates = JSON.parse(storageStates);
    } else {
      formStates = [];
    }
    var state = formStates.find((fs) => fs.formId === this.contentLayout.contentLayoutId && fs.expires > Date.now());
    if (state) {
      state.expires = Date.now() + 1800000;
    } else {
      formStates.push({
        formId: this.contentLayout.contentLayoutId,
        sqlStateNo: this.sqlStateNo,
        expires: Date.now() + 1800000,
      });
    }

    formStates = formStates.filter((fs) => fs.expires > Date.now());
    localStorage.setItem("formstates", JSON.stringify(formStates));

    const body = {
      eventId: this.environment.eventId,
      sqlStateNo: this.sqlStateNo,
      stateString: JSON.stringify(this.orders),
    };

    Axios.post(`./api/attendee/`, body, { responseType: "json" });
  };

  updateOrder = (updatedOrder, personNo = this.activePersonNo) => {
    updatedOrder.sqlStateNo = this.sqlStateNo;
    updatedOrder.contentLayoutId = this.contentLayout.contentLayoutId;
    updatedOrder.eventId = this.environment.eventId;
    updatedOrder.languageCode = this.environment.lang;
    const exhibitorId = getUrlParam("exi");

    if (exhibitorId && !isNaN(exhibitorId)) {
      if (!updatedOrder.orderExtra) updatedOrder.orderExtra = [{ orderExtraId: 0, name: "ExhibitorInvite", value: `${exhibitorId}`, value2: "" }];
      else if (!updatedOrder.orderExtra.some((oe) => oe.name == "ExhibitorInvite")) {
        updatedOrder.orderExtra.push({ orderExtraId: 0, name: "ExhibitorInvite", value: `${exhibitorId}`, value2: "" });
      } else if (updatedOrder.orderExtra.find((oe) => oe.name == "ExhibitorInvite")) {
        updatedOrder.orderExtra.find((oe) => oe.name == "ExhibitorInvite").value = `${exhibitorId}`;
      }
    }

    if (!updatedOrder.orderId) updatedOrder.orderId = ((this.orders.length ?? 0) + 1) * -1;
    if (!updatedOrder.orderRow) updatedOrder.orderRow = [];

    if (!updatedOrder.orderRow.find((row) => row.eventId === this.environment.eventId)) {
      updatedOrder.orderRow.push({
        amount: this.mainEvent.amount,
        comment: "",
        discount: 0,
        eventId: this.mainEvent.eventId,
        orderId: -1,
        orderRowId: updatedOrder.orderRow.length * -1,
        quantity: 1,
        status: null,
        vatPercent: this.mainEvent.vatPercent,
        deleted: false,
      });
    }
    if (updateSqlStateTimeout) {
      clearTimeout(updateSqlStateTimeout);
    }
    updateSqlStateTimeout = setTimeout(this.updateSqlState, 500);

    runInAction(() => {
      this.orders[personNo] = updatedOrder;
      this.orders = [...this.orders];
    });
    const personTypeId = getUrlParam("pti");
    if (personTypeId && !isNaN(personTypeId)) {
      this.addPersonType(parseInt(personTypeId));
    }
  };

  updateOrderRow = (orderRow, forceUncheck = false, orderId = null) => {
    runInAction(() => {
      if (this.orders?.length == 0) this.createOrder();
      let order = this.orders[this.activePersonNo];
      if (orderId) order = this.orders.find((o) => o.orderId === orderId);

      if (!order.orderRow) {
        order.orderRow = [
          {
            amount: this.mainEvent.amount,
            comment: "",
            discount: 0,
            eventId: this.mainEvent.eventId,
            orderId: -1,
            orderRowId: (order.orderRow.length + 1) * -1,
            quantity: 1,
            status: null,
            vatPercent: this.mainEvent.vatPercent,
            deleted: false,
          },
        ];
      }

      if (!order.orderExtra) {
        order.orderExtra = [];
      }

      if (forceUncheck && !order.orderExtra.find((oe) => oe.name === "EventRejected" && oe.value == orderRow.eventId)) {
        order.orderExtra.push({ name: "EventRejected", value: orderRow.eventId, value2: "" });
      } else if (forceUncheck && order.orderExtra.find((oe) => oe.name === "EventRejected" && oe.value == orderRow.eventId)) {
        order.orderExtra = order.orderExtra.filter((oe) => !(oe.name === "EventRejected" && oe.value == orderRow.eventId));
      }

      if (orderRow.eventId) {
        if (!order.orderRow.find((or) => or.eventId === orderRow.eventId) && !forceUncheck) {
          order.orderRow.push(orderRow);
        } else if (!forceUncheck) {
          order.orderRow = order.orderRow.filter((or) => or.eventId !== orderRow.eventId);
        }
      } else if (orderRow.hotelGroupId && orderRow.hotelAllotmentPricingId) {
        if (!order.orderRow.some((or) => or.hotelGroupId === orderRow.hotelGroupId && or.hotelAllotmentPricingId === orderRow.hotelAllotmentPricingId) && !forceUncheck) {
          order.orderRow.push(orderRow);
        } else if (orderRow.deleted) {
          order.orderRow = order.orderRow.filter((or) => or.orderRowId !== orderRow.orderRowId);
        } else {
          const index = order.orderRow.findIndex((or) => (or.orderRowId === orderRow.orderRowId) & (or.hotelGroupId === orderRow.hotelGroupId) & (or.hotelAllotmentPricingId === orderRow.hotelAllotmentPricingId));
          if (index !== -1) {
            order.orderRow[index] = orderRow;
          }
        }
      }

      if (orderRow.eventId) {
        if (!order.orderRow.find((or) => or.eventId === orderRow.eventId) && !forceUncheck) {
          order.orderRow.push(orderRow);
        } else {
          order.orderRow = order.orderRow.filter((or) => or.eventId !== orderRow.eventId);
        }
      } else if (orderRow.hotelGroupId && orderRow.hotelAllotmentPricingId) {
        if (!order.orderRow.some((or) => or.hotelGroupId === orderRow.hotelGroupId && or.hotelAllotmentPricingId === orderRow.hotelAllotmentPricingId) && !forceUncheck) {
          order.orderRow.push(orderRow);
        } else if (orderRow.deleted) {
          console.log("deleted");
          order.orderRow = order.orderRow.filter((or) => or.orderRowId !== orderRow.orderRowId);
        } else {
          const index = order.orderRow.findIndex((or) => (or.orderRowId === orderRow.orderRowId) & (or.hotelGroupId === orderRow.hotelGroupId) & (or.hotelAllotmentPricingId === orderRow.hotelAllotmentPricingId));
          if (index !== -1) {
            order.orderRow[index] = orderRow;
          }
        }
      }
    });
    if (updateSqlStateTimeout) {
      clearTimeout(updateSqlStateTimeout);
    }
    updateSqlStateTimeout = setTimeout(this.updateSqlState, 500);
    runInAction(() => {
      this.orders = [...this.orders];
    });
  };

  updateOrderRowHotel = (hotelGroup, orderRowHotel) => {
    const order = this.orders[this.activePersonNo];
    const orderRows = order?.orderRow?.filter((or) => or.hotelGroup === hotelGroup);
    runInAction(() => {
      orderRows.map((or) => {
        if (orderRowHotel.orderId) {
          if (or.orderRowHotel.some((orh) => orh.orderId == orderRowHotel.orderId)) {
            or.orderRowHotel = or.orderRowHotel.filter((orh) => orh.orderId != orderRowHotel.orderId);
          } else {
            or.orderRowHotel.push(orderRowHotel);
          }
        } else {
          if (or.orderRowHotel.some((orh) => orh.roomMate === orderRowHotel.roomMate)) {
            or.orderRowHotel = or.orderRowHotel.filter((orh) => orh.roomMate != orderRowHotel.roomMate);
          } else {
            or.orderRowHotel.push(orderRowHotel);
          }
        }
      });
    });
    updateSqlStateTimeout = setTimeout(this.updateSqlState, 500);
    runInAction(() => {
      this.orders = [...this.orders];
    });
  };
  removeOrder = (index) => {
    var newOrderList = Array.from(this.orders);
    var newActivePersonNo = 0;

    if (this.orders.length > 1) {
      const orderToRemove = newOrderList[index];
      const indexToRemove = newOrderList.indexOf(orderToRemove);
      if (indexToRemove != -1) {
        if (indexToRemove <= this.activePersonNo) {
          newActivePersonNo = this.activePersonNo - 1;
        }
        newOrderList.splice(index, 1);
      }
    }
    this.activePersonNo = newActivePersonNo;
    this.orders = newOrderList;
  };

  setActiveOrder = (index) => {
    runInAction(() => {
      this.activePersonNo = index;
    });
  };

  setLeader = (index) => {
    var newOrderList = Array.from(this.orders);
    newOrderList = newOrderList.map((n, i) => {
      runInAction(() => {
        n.leader = false;
        if (i == index) n.leader = true;
      });
      return n;
    });
    this.orders = newOrderList;
  };

  createOrder = () => {
    const newOrder = {};
    newOrder.sqlStateNo = this.sqlStateNo; // fix
    newOrder.contentLayoutId = this.contentLayout.contentLayoutId;
    newOrder.eventId = this.contentLayout.eventId;
    newOrder.languageCode = this.environment.lang;
    newOrder.orderId = 0;

    const exhibitorId = getUrlParam("exi");
    if (exhibitorId && !isNaN(exhibitorId)) {
      newOrder.orderExtra = [{ orderExtraId: 0, name: "ExhibitorInvite", value: `${exhibitorId}`, value2: "" }];
    }

    if (!newOrder.orderRow) {
      newOrder.orderRow = [];
    }

    if (!newOrder.orderRow.find((row) => row.eventId == this.mainEvent.eventId)) {
      newOrder.orderRow.push({
        amount: this.mainEvent.amount,
        comment: "",
        discount: 0,
        eventId: this.mainEvent.eventId,
        orderId: -1,
        orderRowId: newOrder.orderRow.length * -1,
        quantity: 1,
        status: null,
        vatPercent: this.mainEvent.vatPercent,
        deleted: false,
      });
    }
    if (updateSqlStateTimeout) {
      clearTimeout(updateSqlStateTimeout);
    }

    updateSqlStateTimeout = setTimeout(this.updateSqlState, 500);
    if (this.orders.length > 0 && toJS(this.orders)[this.activePersonNo]) {
      this.checkForGroupTransferValues(this.orders[this.activePersonNo], newOrder);
    }

    if (this.orders.length == 1) {
      this.orders[0].leader = true;
    } else {
    }
    this.orders.push(newOrder);
    this.configureValidation();
    //this.activePersonNo += 1;
    if (this.orders.length > 0) {
      this.activePersonNo = this.orders.length - 1;
    } else {
      this.activePersonNo = 0;
    }
    const personTypeId = getUrlParam("pti");
    if (personTypeId && !isNaN(personTypeId)) {
      newOrder.personTypes = [{ orderId: 0, personTypeId: parseInt(personTypeId) }];
    }
  };

  addPersonType = (personTypeId) => {
    if (this.orders.length === 0) {
      this.createOrder();
    }
    runInAction(() => {
      if (!this.orders[this.activePersonNo].personTypes) {
        this.orders[this.activePersonNo].personTypes = [];
      }
      if (!this.orders[this.activePersonNo].personTypes.find((pt) => pt.personTypeId === personTypeId)) {
        this.orders[this.activePersonNo].personTypes.push({ orderId: 0, personTypeId });
        this.orders[this.activePersonNo] = { ...this.orders[this.activePersonNo] };
        this.orders = [...this.orders];
      }
    });
  };

  removePersonType = (personTypeId) => {
    if (this.orders?.[this.activePersonNo]?.personTypes) {
      runInAction(() => {
        this.orders[this.activePersonNo].personTypes = this.orders[this.activePersonNo].personTypes.filter((pt) => pt.personTypeId !== personTypeId && !pt.personTypeOrderId);
        this.orders = [...this.orders];
      });
    }
  };

  checkForGroupTransferValues(previousOrder, newOrder) {
    if (this.questions.length > 0) {
      this.modules.map((m) => {
        if (m.settings?.groupTransfer) {
          if (m.type === "FIELD") {
            const field = this.fields.find((f) => f.fieldId == m.settings.fieldId);
            if (previousOrder[toCamelCase(field.type)]?.[toCamelCase(field.name)]) {
              if (!newOrder[toCamelCase(field.type)]) {
                newOrder[[toCamelCase(field.type)]] = {};
              }
              newOrder[[toCamelCase(field.type)]][toCamelCase(field.name)] = previousOrder[toCamelCase(field.type)][toCamelCase(field.name)];
            }
          } else if (m.type === "EVENT") {
            let row = previousOrder?.orderRow?.find((or) => or.eventId == m.settings.eventId);
            if (row) {
              if (!newOrder.orderRow) {
                newOrder.orderRow = [];
              }
              newOrder.orderRow.push({
                ...row,
                orderId: -1,
                orderRowId: newOrder.orderRow.length * -1,
              });
              this.checkEventAvailability(row.eventId, -1, this.sqlStateNo, true).then((res) => {
                if (res === false) {
                  const ord = deepClone(this.orders.find((x) => x.orderId == newOrder.orderId));
                  ord.orderRow = ord.orderRow.filter((x) => x.eventId != row.eventId);
                  runInAction(() => {
                    const target = this.orders.find((x) => x.orderId == newOrder.orderId);
                    target.orderRow = ord.orderRow;
                  });
                }
              });
            }
          } else if (m.type === "QUESTION") {
            const answer = previousOrder?.answer?.find((a) => a.questionId == m.settings.questionId);
            if (answer) {
              if (!newOrder.answer) {
                newOrder.answer = [];
              }
              newOrder.answer.push({
                answerId: 0,
                interactionKey: null,
                orderId: 0,
                questionId: m.settings.questionId,
                answerRow: answer.answerRow?.map((ar) => {
                  return {
                    answerId: 0,
                    answerRowId: 0,
                    questionOptionId: ar.questionOptionId,
                    text: ar.text,
                    deleted: false,
                  };
                }),
              });
            }
          }
        }
      });
    }
  }

  checkEventAvailability = async (eventId, orderId, sqlStateNo, add = false) => {
    const count = (this.orders.filter((x) => x.orderRow?.some((y) => y.eventId === eventId))?.length ?? 0) + (add ? 1 : 0);
    const { data } = await Axios.get(`./api/attendee/status/${eventId}${orderId && orderId > 0 ? "/" + orderId : ""}?sqlStateNo=${sqlStateNo ? sqlStateNo : 0}&count=${count}`);
    return data.available;
  };

  configureValidation = () => {
    var oldValidations = deepClone(this.validations);

    this.validations = [];
    const layout = this.current.scopedLayout ? this.current.scopedLayout : this.contentLayout;
    layout?.contentLayoutModules.map((clm) => {
      const validationObject = { page: clm.pages, valid: false, id: clm.contentModule.contentModuleId, reason: "" };

      if (clm.contentModule.type == "FIELD" || clm.contentModule.type == "QUESTION") {
        if (
          clm.contentModule.settings.required ||
          (clm.contentModule.settings.fieldType &&
            (clm.contentModule.settings.fieldType.toLowerCase() == "email" || clm.contentModule.settings.fieldType.toLowerCase() == "firstname" || clm.contentModule.settings.fieldType.toLowerCase() == "lastname"))
        ) {
          console.log("field");
          validationObject.reason = "required";
          if (clm.contentModule.settings?.fieldType) {
            validationObject.decorator = clm.contentModule.settings.fieldType.toLowerCase();
          }
        } else {
          validationObject.valid = true;
        }
        this.validations.push(validationObject);
      } else if (clm.contentModule.type == "EVENT" || clm.contentModule.type == "EVENT_GROUP") {
        if (clm.contentModule.settings.required && !clm.contentModule.settings.prechecked) {
          validationObject.reason = "required";
        } else {
          validationObject.valid = true;
        }
        this.validations.push(validationObject);
      }

      if (clm.contentModule.type == "PAYMENT_OPTIONS" && clm.contentModule.settings.paymentMethods.includes("invoice")) {
        defaultInvoiceFields.map((df) => {
          let defaultValidity = false;
          switch (df) {
            case "Email":
            case "Telephone1":
            case "Address2":
            case "GLN":
              defaultValidity = true;
              break;
            default:
              defaultValidity = false;
              break;
          }
          this.validations.push({ page: clm.pages, valid: defaultValidity, id: `INVOICE_${df}`, label: df + "ValidationMessage", type: df });
        });
        if (clm.contentModule.settings.paymentMethods.length > 1) {
          this.validations.push({ page: clm.pages, valid: true, id: clm.contentModule.contentModuleId, label: "PaymentOption", message: "PaymentOptionValidationMessage" });
        }
      }

      if (clm.contentModule.type == "PAYMENT_OPTIONS_TWO") {
        defaultInvoiceFields.map((df) => {
          let defaultValidity = false;

          let currentValidity = oldValidations.find((v) => v.id == `INVOICE_${df}`);
          if (currentValidity != undefined) {
            currentValidity = currentValidity.valid;
          }
          switch (df) {
            case "Email":
            case "Address1":
            case "Address2":
            case "GLN":
              defaultValidity = true;
              break;
            default:
              defaultValidity = false;
              break;
          }
          this.validations.push({ page: clm.pages, valid: currentValidity ? currentValidity : defaultValidity, id: `INVOICE_${df}`, label: df + "ValidationMessage", type: df });
        });
        if (clm.contentModule.settings.paymentMethods.length > 1) {
          this.validations.push({ page: clm.pages, valid: true, id: clm.contentModule.contentModuleId, label: "PaymentOption", message: "PaymentOptionValidationMessage" });
        }
      }

      if (clm.conditions && typeof clm.conditions == "string" && clm.conditions != "null") {
        clm.conditions = JSON.parse(clm.conditions);
      }
      if (!this.conditions[clm.contentLayoutModuleId]) this.conditions[clm.contentLayoutModuleId] = { hidden: false, readonly: false, required: false };
      this.checkConditions(clm.contentLayoutModuleId);
    });

    const mustIncludeDecorators = ["email", "firstname", "lastname"];
    const includedDecorators = mustIncludeDecorators.filter((decorator) => this.validations.some((validation) => validation?.decorator?.toLowerCase() === decorator.toLowerCase()));

    const allDecoratorsIncluded = includedDecorators.length === mustIncludeDecorators.length;
    const missingDecorators = mustIncludeDecorators.filter((decorator) => !this.validations.some((validation) => validation?.decorator?.toLowerCase() === decorator.toLowerCase()));

    if (!allDecoratorsIncluded && this.environment.name === "FORM") {
      missingDecorators.forEach((decorator) => {
        this.validations.push({ decorator, reason: "required", id: 0, valid: false, page: 0 });
      });
    }
  };

  triggerValidation = (trigger = true) => {
    runInAction(() => {
      this.validate = trigger;
    });
  };

  //Global
  configureEnviroment = (layout, res) => {
    runInAction(() => {
      const lang = getUrlParam("lang");
      if (lang) {
        this.environment.lang = lang;
      } else {
        this.environment.lang = res.defaultLanguage;
      }
      if (layout.type == "FORM") {
        this.environment.name = "FORM";
        this.sqlStateNo = res.sqlStateNo;
        this.configureValidation();
      } else if (layout.type == "SURVEY") {
        this.environment.name = "SURVEY";
        this.sqlStateNo = res.sqlStateNo;
        this.configureValidation();
      }
    });
  };

  replaceTags = async (textContent) => {
    //this.orders.length > 0 && this.orders[this.activePersonNo]?.orderId &&
    if (textContent && /\[.*\]/.test(textContent)) {
      var response = await Axios.put(`./api/tag/tagreplace`, {
        text: textContent,
        orderId: toJS(this.orders)?.[this.activePersonNo]?.orderId ?? 0,
        eventId: this.environment.eventId,
        lang: this.environment.lang,
      });
      return response.data.text;
    } else {
      return textContent;
    }
  };

  //Conditions
  checkConditions = (contentLayoutModuleId) => {
    let targets = [];
    if (this.contentLayout.contentLayoutModules.length > 0) {
      this.contentLayout.contentLayoutModules.map((clm) => {
        if (Array.isArray(clm.conditions) && (!contentLayoutModuleId || clm.conditions.some((c) => c.sourceId == contentLayoutModuleId) || clm.contentLayoutModuleId == contentLayoutModuleId)) {
          targets.push(clm);
        }
      });
    }
    if (Array.isArray(this.contentLayout.conditions) && (!contentLayoutModuleId || this.contentLayout.conditions.some((c) => c.sourceId == contentLayoutModuleId))) {
      targets.push(this.contentLayout);
    }
    targets.map((target) => {
      this.resolveQuery(target);
    });
  };

  resolveQuery = (target) => {
    //ALla conditions för det här target elementet
    //filtrerar alla conditons som inte är i grupp 0

    // let queryStr = "";
    let conditionLists = {};

    for (const action in conditionConstants.actions) {
      if (conditionConstants.actions.hasOwnProperty(action)) {
        conditionLists[conditionConstants.actions[action]] = target.conditions.filter((el) => el.action == conditionConstants.actions[action]);
      }
    }

    for (const action in conditionLists) {
      if (conditionLists.hasOwnProperty(action)) {
        if (conditionLists[action] && conditionLists[action].length > 0) {
          const secondaryActions = [
            ...new Set(
              conditionLists[action].map((c) => {
                return c.secondaryAction;
              })
            ),
          ];
          for (const secondaryAction of secondaryActions) {
            let queryStr = "";
            conditionLists[action]
              .filter((c) => c.secondaryAction === secondaryAction)
              .sort((a, b) => {
                return a.sortOrder - b.sortOrder;
              })
              .map((c) => {
                if (c.prefix) queryStr += " " + c.prefix.replace("AND", "&&").replace("OR", "||") + " ";
                queryStr += this.resolveCondition(c);
                if (c.suffix) queryStr += " " + c.suffix.replace("AND", "&&").replace("OR", "||") + " ";
              });
            try {
              let result = eval(queryStr);
              this.executeAction(action, secondaryAction, target.contentLayoutModuleId, result);
            } catch (err) {
              console.error(`Invalid Condition in {${target.contentModule?.type}} module: #${target.contentModule?.cssId}`, err);
            }
          }
        }
      }
    }
  };

  resolveCondition = (condition) => {
    const source = this.extractElement(condition.sourceId);
    let conditionStr = "";
    if (source) {
      const sourceValue = conditionNavigator.navigate(source, this.orders, this.activePersonNo);

      if (source.contentModule.type === "EVENT" && condition.operator === "FULL") {
        if (this.breakoutsFullbooked[source.contentModule.settings.eventId]) {
          conditionStr = `('true' == 'true')`;
        } else {
          conditionStr = `('false' == 'true')`;
        }
      } else if (Array.isArray(sourceValue) || condition.operator === conditionConstants.operators.LIKE) {
        conditionStr = this.resolveCheckboxCondition(sourceValue, condition);
      } else {
        if ((condition.operator.includes("GREATER") || condition.operator.includes("LESS")) && sourceValue) {
          conditionStr = `(${sourceValue.length} ${conditionTranslator.translateOperator(condition.operator)} ${condition.value})`;
        } else if (condition.operator.includes("ANY")) {
          conditionStr = `(${sourceValue?.length ?? 0} > 0)`;
        } else {
          conditionStr = `('${sourceValue}' ${conditionTranslator.translateOperator(condition.operator)} '${condition.value}')`;
        }
      }
    }
    return conditionStr;
  };

  resolveCheckboxCondition = (sourceValue, condition) => {
    let cStr = "";
    if (condition.operator == conditionConstants.operators.ANY && sourceValue.length > 0) {
      cStr = "(true)";
    } else if (condition.operator == conditionConstants.operators.LIKE && sourceValue && sourceValue.toString().includes(condition.value)) {
      cStr = "(true)";
    } else if (condition.operator == conditionConstants.operators.EQUAL) {
      cStr = `(${sourceValue.some((sv) => sv == condition.value)})`;
    } else if (condition.operator == conditionConstants.operators.NOT_EQUAL) {
      cStr = `(${!sourceValue.some((sv) => sv == condition.value)})`;
    } else if (condition.operator == conditionConstants.operators.LESS_THAN_OR_EQUAL_TO) {
      cStr = `(${sourceValue.length <= condition.value})`;
    } else if (condition.operator == conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO) {
      cStr = `(${sourceValue.length >= condition.value})`;
    } else {
      cStr = "(false)";
    }
    return cStr;
  };

  executeAction = (action, secondaryAction, id, value) => {
    if (action === "persontype") {
      if (value) {
        this.addPersonType(parseInt(secondaryAction.replace("pt", "")));
      } else {
        this.removePersonType(parseInt(secondaryAction.replace("pt", "")));
      }
    } else {
      runInAction(() => {
        if (!this.conditions[id]) this.conditions[id] = { hidden: false, readonly: false, required: false };
        switch (action) {
          case conditionConstants.actions.hidden:
            this.conditions[id].hidden = !value;
            break;
          case conditionConstants.actions.require:
            this.conditions[id].required = value;
            break;
          case conditionConstants.actions.readonly:
            this.conditions[id].readonly = value;
          case conditionConstants.actions.CustomError:
            break;
          default:
            break;
        }
      });
    }
  };

  extractElement = (id) => {
    const source = this.contentLayout.contentLayoutModules.find((clm) => {
      return clm.contentLayoutModuleId === id;
    });
    return source;
  };

  checkMainEventBookingStatus = async () => {
    const { data } = await Axios.get(`./api/attendee/status/${this.mainEvent.eventId}${this.orders.length > 0 ? "/" + this.orders[this.activePersonNo].orderId : ""}?sqlStateNo=${this.sqlStateNo}`).catch((err) => {
      console.error(err);
    });
    runInAction(() => {
      if (data.available) {
        this.mainEventFullbooked = false;
      } else {
        this.mainEventFullbooked = true;
      }
    });
    return data.available;
  };
}

export default createContext(new Store());
